import React from 'react'
import { FaCheck } from '@react-icons/all-files/fa/FaCheck'

const RadioButton = (props) => {

  return (
    <button
      className={`${props.className} ${props.selected ? 'active' : ''}`}
      id={props.idName ?? ''}
      disabled={props.disabled}
      onClick={props.onClick}
      style={props.style}
      >
      {props.booleanSelector ? <span />  : (
        <FaCheck  size={12} color="white"/>
      )}
      
    </button>
  )
}

export default RadioButton